namespace OfficeGuy {
    export class FilteredTable {
        static Init($Table) {
            $("input[data-sumit-filteredtableindex], input[data-sumit-filteredtablekey]").on("input", function () {
                FilteredTable.Refresh($Table);
            });
        }
        static Refresh($Table) {
            var Filters = FilteredTable.ListFilters();
            $Table.find("tbody tr").each(function () {
                var $Row = $(this);
                var Valid = true;
                for (var i = 0; i < Filters.length; i++) {
                    if (Filters[i].Value != null && Filters[i].Value.length != 0) {
                        var RowValue = $Row.data("sumit-filteredtablekey-" + Filters[i].Key).toString();
                        switch (Filters[i].Type) {
                            case "Contains":
                                Valid = RowValue.indexOf(Filters[i].Value) != -1;
                                break;
                            case "NotContains":
                                Valid = RowValue.indexOf(Filters[i].Value) == -1;
                                break;
                            case "Larger":
                                Valid = Number(RowValue) >= Filters[i].Value;
                                break;
                            case "Smaller":
                                Valid = Number(RowValue) <= Filters[i].Value;
                                break;
                        }
                        if (!Valid)
                            break;
                    }
                }

                $Row.toggleClass("hide", !Valid);
            });
        }
        static ListFilters() {
            var ToReturn = new Array();
            $("input[data-sumit-filteredtablekey]").each(function () {
                var $Input = $(this);
                var Key = $Input.data("sumit-filteredtablekey");
                var Type;
                var Value = <any>$Input.val().toString().toLowerCase();
                if (Key[0] == '-') {
                    Key = Key.substring(1);
                    Type = "NotContains";
                }
                else if (Key[0] == '>') {
                    Key = Key.substring(1);
                    Type = "Larger";
                    if (Value)
                        Value = Number(Value);
                }
                else if (Key[0] == '<') {
                    Key = Key.substring(1);
                    Type = "Smaller";
                    if (Value)
                        Value = Number(Value);
                }
                else
                    Type = "Contains";
                ToReturn.push({
                    Key: Key,
                    Value: Value,
                    Type: Type
                });
            });
            return ToReturn;
        }
    }
}
